import { inject, Injectable } from '@angular/core';
import { ClockLocationData } from '@app/reducers/orm/clock-location/clock-location.model';
import { ApiGateway } from '@sb/shared/api';

import { AutoApproveTimesheetHoursOption, TimeTrackingMethod } from '../chapter.model';

export interface TimeTrackingSettingsPayload {
  timeTrackingMethod: TimeTrackingMethod;
  autoApproveSchedule: boolean;
  autoApproveClockedTime: boolean;
  clockLocation?: ClockLocationData;
}

export interface TimeTrackingSettings extends Omit<
  TimeTrackingSettingsPayload,
  'autoApproveSchedule' | 'autoApproveClockedTime'
> {
  autoApproveSchedule: AutoApproveTimesheetHoursOption;
  autoApproveClockedTime: AutoApproveTimesheetHoursOption;
}

@Injectable({
  providedIn: 'root',
})
export class OnboardingTimeTrackingService {
  #api = inject(ApiGateway);

  savePreferences(settings: TimeTrackingSettings) {
    return this.#api.post('onboarding/time_tracking', this.#getTimeTrackingPayload(settings));
  }

  #getTimeTrackingPayload(settings: TimeTrackingSettings): TimeTrackingSettingsPayload {
    return {
      ...settings,
      autoApproveSchedule: settings.autoApproveSchedule === AutoApproveTimesheetHoursOption.YES,
      autoApproveClockedTime: settings.autoApproveClockedTime === AutoApproveTimesheetHoursOption.YES,
    };
  }
}
